import { Helpers } from '@bode-canada/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(dayOfYear);
dayjs.extend(localizedFormat);

const defaultDateFormat = 'YYYY-MM-DD';

export const formatDatetime = ({
  format = defaultDateFormat,
  datetime,
} = {}) => dayjs(datetime || Date.now()).format(format);

export const createDate = ({ format, datetime } = {}) => dayjs(datetime || Date.now(), format);

export const getFromToTimeString = (fromDatetime, toDatetime) => {
  const formattedFromDate = formatDatetime({ format: 'MMMM D, YYYY', datetime: fromDatetime });
  const formattedFromTime = formatDatetime({ format: 'h:mma', datetime: fromDatetime });
  const formattedToTime = formatDatetime({ format: 'h:mma', datetime: toDatetime });

  return `${formattedFromDate} from ${formattedFromTime} to ${formattedToTime}`;
};

export const getDiff = ({ fromDatetime, toDatetime, unit }) => dayjs(fromDatetime)
  .diff(toDatetime, unit);

export const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const toLocalDate = (dateString) => (
  Helpers.TypeHelper.isString(dateString)
    ? new Date(dateString).toISOString().slice(0, -1)
    : dateString
);
